module.exports = __webpack_public_path__ + "files/651e15b8e744f48672e2837749bf1b98.png";